import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { getAllCountries, getAllArchitect } from "../service/MainService"; 

export const AppContext = createContext({
  profileType: "",
  setProfileType: () => {},
  handleLogout: () => {},
  setSelectedCountry: () => {},
  selectedCountry: '',
  setdataStore: () => {},
  dataStore: [],
  collabStore: [], 
  setCollabStore: () => {},
  scamStore: [],
  setScamStore: () => {},

});

export const AppContextProvider = ({ children }) => {
  const [profileType, setProfileType] = useState("");
  const [selectedCountry, setSelectedCountry] = useState('');
  const [dataStore,setdataStore] = useState([]);
  const [collabStore, setCollabStore] = useState([])
  const [scamStore, setScamStore] = useState([])

  const navigate = useNavigate()

  const [country, setCountry] = useState([]);
  const [architect, setArchitect] = useState([]);

  const [emailVerification,setemailVerification] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const architectList = await getAllArchitect();
        setArchitect(architectList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const CountryList = await getAllCountries();
        setCountry(CountryList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };
  
  return (
    <AppContext.Provider
      value={{
        profileType,
        setProfileType,
        handleLogout,
        setSelectedCountry,
        selectedCountry,
        setdataStore,
        dataStore,
        collabStore, 
        setCollabStore,
        scamStore,
        setScamStore,
        country,
        architect,
        emailVerification,
        setemailVerification,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

